<template>
  <div style="padding: 24px 24px 0">
    <TslBreadcrumb :titles="contentHeadQuery" :showTitle="false" />
    <div class="operate-table-wrapper">
      <div class="title">产品信息</div>
      <div class="operate-table">
        <div>
          <div>
            <span class="key">产品编码</span><span class="value"></span>{{ formState.identifier }}
          </div>
          <div>
            <span class="key">产品名称</span><span class="value"></span>{{ formState.name }}
          </div>
        </div>
        <div>
          <div>
            <span class="key">分类</span><span class="value"></span>{{ formState.categoryName }}
          </div>
          <div>
            <span class="key">行业</span><span class="value"></span
            >{{ formState.industryStr || "-" }}
          </div>
        </div>
        <div>
          <div>
            <span class="key">描述</span><span class="value"></span>{{ formState.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="property-table">
    <a-tabs v-model:activeKey="activeKey" @change="tabChange">
      <a-tab-pane key="1" v-if="namespace === 'standard'">
        <template #tab>
          <div class="tab"><svg-icon class="icon" iconClass="basic-info1"></svg-icon>历史版本</div>
        </template>
      </a-tab-pane>
      <a-tab-pane key="2">
        <template #tab>
          <div class="tab"><svg-icon class="icon" iconClass="basic-info2"></svg-icon>修改记录</div>
        </template>
      </a-tab-pane>
    </a-tabs>

    <a-table
      v-show="activeKey == '1'"
      class="page-table"
      :dataSource="dataSource"
      :columns="columns"
      :pagination="pagination"
      :rowKey="(record) => record.id"
      :scroll="{ y: `calc(100vh - 560px)` }"
    >
      <template #bodyCell="{ column, text, record }">
        <template v-if="column.key === 'version'">
          {{ formatVersion(text) }}
        </template>
        <template v-if="column.key === 'functionModel'">
          <a class="oprea-btn" @click.prevent="seeFunModel(record)">查看</a>
        </template>
        <template v-if="column.key === 'releasedTime'">
          <span>{{ record.releasedTime || "-" }}</span>
        </template>
        <template v-if="column.key === 'json'">
          <a class="oprea-btn" @click.prevent="jsonOperate(record, 'view')">查看</a>
          <a class="oprea-btn" @click.prevent="jsonOperate(record, 'down')">下载</a>
        </template>
      </template>
    </a-table>

    <div v-if="activeKey == '2'">
      <div class="modify_box" v-if="historyDataSourceCope.length">
        <div class="left">
          <a-checkbox @change="checkFun" v-model:checked="checked1"
            >仅显示已发布的修改记录</a-checkbox
          >
          <div
            class="left_box"
            @click="selectVersion(item)"
            v-for="item in historyDataSource"
            :key="item.id"
          >
            <div>
              <span class="name">{{ item.createTime }}</span>
              <a-tag
                :class="{ delete: item.status == '2' }"
                v-if="item.status == '2' || item.status == '3'"
                color="red"
                >{{ statusValue[item.status] }}</a-tag
              >
              <a-tag v-else-if="item.status == '0'">{{ statusValue[item.status] }}</a-tag>
              <a-tag color="blue" v-else>{{ statusValue[item.status] }}</a-tag>
            </div>
            <div>
              <span>{{ item.createUserName }}</span>
              <a-button class="compareBtn" ghost type="primary" size="small">+ 对比</a-button>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="version_box">
            <div>
              <template v-if="oldValue">
                <span>{{ oldId.createTime }} </span>
                <span>
                  <a-tag :color="oldId.status === 1 ? 'blue' : oldId.status === 2 ? 'red' : ''">
                    {{ statusValue[oldId.status] }}
                  </a-tag>
                </span>
                <span>{{ oldId.createUserName }}</span>
                <span @click="delcompare(0)">
                  <svg-icon iconClass="function-close"></svg-icon>
                </span>
              </template>
            </div>
            <div>对比</div>
            <div>
              <template v-if="newValue">
                <span>{{ newId.createTime }} </span>
                <span>
                  <a-tag :color="newId.status === 1 ? 'blue' : newId.status === 2 ? 'red' : ''">
                    {{ statusValue[newId.status] }}
                  </a-tag>
                </span>
                <span>{{ newId.createUserName }}</span>
                <span @click="delcompare(1)">
                  <svg-icon iconClass="function-close"></svg-icon
                ></span>
              </template>
            </div>
          </div>
          <code-diff
            diffStyle="word"
            :old-string="oldValue"
            outputFormat="side-by-side"
            :new-string="newValue"
            :context="50"
            language="json"
          />
          <div class="tipTag">
            <a-tag color="#ccffd8">增加的内容</a-tag>
            <a-tag color="#ffd7d5">修改的内容</a-tag>
          </div>
          <!-- outputFormat="side-by-side" -->
        </div>
      </div>
      <div class="empty" v-else>
        <a-empty :image="simpleImage" />
      </div>
    </div>
  </div>
  <div ref="modal" class="modal-table-cover">
    <a-modal
      :width="800"
      :getContainer="() => $refs.modal"
      okText="关闭"
      destroyOnClose
      v-model:visible="showModelModal"
      title="功能"
      @ok="
        () => {
          showModelModal = false;
        }
      "
    >
      <FunModelModal :record="selectRecord" namespace="standard" />
    </a-modal>
    <JsonDrawer :record="selectRecord" ref="jsonDrawerRef" />
  </div>
</template>

<script setup>
import { Tag } from "ant-design-vue";
import { CodeDiff } from "v-code-diff";
import { reactive, ref, nextTick } from "vue";
import { useRouter } from "vue-router";
import { formatVersion } from "@/utils/tool.js";
import { message, Empty } from "ant-design-vue";
import { getEditHistory } from "@/api/console/model/product";
import { getProductHistoryList } from "@/api/console/model/model-definition";
import FunModelModal from "./modals/fun-model.vue";
import JsonDrawer from "./drawers/json-drawer.vue";
import TslBreadcrumb from "@/components/model/breadcrumb";
import { saveAs } from "file-saver";
import { getJson } from "./property-table";
const ATag = Tag;
const AEmpty = Empty;
const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
const columns = [
  {
    title: "序号",
    customRender: (record) => {
      return `${record.index + 1}`;
    },
    key: "sn"
  },
  {
    title: "版本",
    dataIndex: "version",
    key: "version"
  },
  {
    title: "功能",
    dataIndex: "functionModel",
    key: "functionModel"
  },
  {
    title: "发布时间",
    dataIndex: "releasedTime",
    key: "releasedTime",
    ellipsis: true
  },
  {
    title: "物模型JSON",
    dataIndex: "json",
    key: "json",
    width: 120
  }
];
const contentHeadQuery = [{ path: "/console/model/product", name: "产品管理" }, { name: "详情" }];
const statusValue = ref({
  0: "未发布",
  1: "已发布",
  2: "删除",
  // 3: "发布撤销"
  3: "未发布"
});
const jsonDrawerRef = ref(null);
let checked1 = ref(false);

const oldValue = ref("");
const newValue = ref("");
const oldId = ref({});
const newId = ref({});
const selectVersion = (item) => {
  if (item.createTime === oldId.value?.createTime || item.createTime === newId.value?.createTime) {
    message.info("请选择不同的记录");
    return;
  }
  const value = JSON.stringify(JSON.parse(item.model), null, 2);
  if (!oldValue.value) {
    oldValue.value = value;
    oldId.value = item;
  } else if (!newValue.value) {
    newValue.value = value;
    newId.value = item;
  } else {
    message.info("请先删除其中一项对比项目");
  }
};
const checkFun = () => {
  if (checked1.value) {
    historyDataSource.value = [];
    historyDataSourceCope.value.map((item) => {
      if (item.status == 1) {
        historyDataSource.value.push(item);
      }
    });
  } else {
    historyDataSource.value = JSON.parse(JSON.stringify(historyDataSourceCope.value));
  }
};

//路由
const router = useRouter();
// ---------------table部分 --------start
const dataSource = ref([]);
const historyDataSource = ref([]);
const historyDataSourceCope = ref([]);
const activeKey = ref("1");
const selectRecord = ref({});
const namespace = router.currentRoute.value.query.tab === "2" ? "custom" : "standard";
const pagination = reactive({
  pageNum: 1,
  pageSize: 10,
  total: 10,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "30", "50"]
});
let formState = reactive({});
// 查看功能物模型
const showModelModal = ref(false);
const seeFunModel = (record) => {
  selectRecord.value = record;
  selectRecord.value.productVerId = record.id;
  showModelModal.value = true;
};

const getTableData = () => {
  let query = router.currentRoute.value.query;
  activeKey.value = query.tab;
  if (activeKey.value === "1") getVerList();
  else if (activeKey.value === "2") getHistory();
};
const getVerList = async () => {
  if (dataSource.value && dataSource.value.length) return;
  const query = router.currentRoute.value.query;

  const res = await getProductHistoryList(query.id);
  if (res.success) {
    dataSource.value = res.data ? res.data.reverse() : [];
  }
};

const getHistory = async () => {
  if (historyDataSource.value && historyDataSource.value.length) return;
  const params = {
    productId: router.currentRoute.value.query.id
  };
  const res = await getEditHistory(params);
  if (res.success) {
    historyDataSource.value = res.data ? res.data : [];
    historyDataSourceCope.value = JSON.parse(JSON.stringify(historyDataSource.value));
  }
};

const getCurrentData = () => {
  let baisc = window.sessionStorage.getItem("productHistoryBaisc");
  if (!baisc) return;
  formState = reactive(JSON.parse(baisc));
};

const delcompare = (type) => {
  if (type) {
    newValue.value = "";
    newId.value = {};
  } else {
    oldValue.value = "";
    oldId.value = {};
  }
};

const tabChange = (val) => {
  if (val === 1) getVerList();
  else if (val === 2) getHistory();
};

/**
 * @description: 物模型查看和下载
 * @param {*} record
 * @param {*} type
 * @return {*}
 */
const jsonOperate = async (record, type) => {
  const res = await getJson(record, record.id);
  if (type === "down") {
    const blob = new Blob([JSON.stringify(res)]);
    saveAs(blob, record.identifier || res.identifier || "product" + ".json");
    message.success("下载成功");
  } else if (type === "view") {
    nextTick(() => {
      jsonDrawerRef.value.open(res);
    });
  }
};

getCurrentData();
getTableData();
</script>

<style lang="less" scoped>
:deep(.breadcrumb-component) {
  padding: 0;
  background: transparent;
}
/deep/.ant-tag-has-color {
  color: #333;
}
/deep/ .file-header {
  display: none !important;
}
.title {
  .font(18px,22px,22px,@weight:500);

  margin-bottom: 24px;
}
.oprea-btn {
  margin-right: 16px;
  color: #5e66f2;
}
.a-link {
  &:hover {
    color: #000;
  }
}
.operate-table-wrapper {
  margin-top: 8px;
  padding: 24px;
  background: #fff;
  border-radius: 4px;
}
.operate-table {
  display: flex;
  > div {
    flex: 1;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    .key {
      display: inline-block;
      width: 80px;
      color: #86909c;
    }
    .value {
      color: @text-color-primary;
    }
    > div:nth-child(2) {
      margin-top: 16px;
    }
  }

  .form-content {
    word-break: break-all;
  }
}
.property-table {
  margin: 16px 24px 24px;
  padding: 24px;
  background: @base-bg-default-color;
  border-radius: 4px;

  .back-button {
    margin-bottom: 12px;
    color: #5e66f2;
    cursor: pointer;

    /deep/ .back-icon {
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
}
.modify_box {
  display: flex;
  .left {
    width: 30%;
    height: 500px;
    margin-right: 16px;
    overflow: scroll;
    // border-right: 1px solid;
    .left_box {
      padding: 8px;
      color: #4e5969;
      border-bottom: 1px solid #e5e6eb;
      cursor: pointer;
      transition: all 0.3s;
      .compareBtn {
        opacity: 0;
        transition: all 0.3s;
      }
      // .name {
      //   font-size: 18px;
      // }
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 28px;
        &:not(:last-child) {
          margin-bottom: 10px;
        }
        .ant-tag {
          margin: 0;
          border: none;
        }
      }

      &:hover {
        background: #f7f8fa;
      }
      &:hover .compareBtn {
        opacity: 1;
      }
    }
  }
  .right {
    flex: 1;
    // padding: 0 20px;
    padding: 8px;
    // border: 1px solid var(--color-border-default, #ddd);
    .version_box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      // font-weight: 500;
      color: #1d2129;
      > div {
        position: relative;
        display: flex;
        align-items: center;
        padding: 5px 12px;
        &:not(:nth-child(2)) {
          flex: 1;
          border: 1px solid #e5e6eb;
          border-radius: 4px;
        }
        > span {
          padding-right: 12px;
          &:last-child {
            position: absolute;
            right: 12px;
            padding-right: 0;
            cursor: pointer;
          }
        }
      }
    }
    .tipTag {
      padding: 8px 0;
      text-align: center;
      border: 1px solid #e5e6eb;
      border-top: none;
    }
  }
}
.code-diff-view {
  height: 400px;
  margin: 0;
  border-radius: 0;
}
.delete {
  text-decoration: line-through;
}
.vue-code-diff {
  margin: 0;
  padding: 0;

  /deep/ .d2h-wrapper {
    .d2h-file-wrapper {
      margin-bottom: unset;
      border: unset;
      border-radius: unset;

      .d2h-files-diff {
        display: flex;

        .d2h-file-side-diff {
          position: relative;
          overflow: hidden;
          background-color: #fee8e9;

          .d2h-code-wrapper {
            .d2h-diff-table {
              .d2h-diff-tbody {
                tr {
                  // 设置表头的第2个单元格大小高度
                  td:nth-child(2).d2h-info {
                    width: 100%;
                    height: 15px;

                    .d2h-code-side-line {
                      height: 100%;
                    }
                  }

                  // 当单行溢出换行时，需要把行号的高度撑满
                  td.d2h-code-side-linenumber {
                    height: 100%;
                  }

                  // 删除代码的变更
                  td.d2h-del {
                    .d2h-code-side-line {
                      .d2h-code-line-ctn.hljs {
                        height: auto;
                        font-size: 14px;
                        font-family: "Microsoft YaHei", "微软雅黑";
                        white-space: pre-line; // 单行溢出换行
                      }
                    }
                  }

                  // 新增代码的变更
                  td.d2h-ins {
                    .d2h-code-side-line {
                      .d2h-code-line-ctn.hljs {
                        height: auto;
                        font-size: 14px;
                        font-family: "Microsoft YaHei", "微软雅黑";
                        white-space: pre-line; // 单行溢出换行
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .d2h-file-side-diff + .d2h-file-side-diff {
          background-color: #dfd;
        }
      }
    }
  }
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}
</style>
